module.exports = __webpack_public_path__ + "static/karta-gwarancyjna-baranski-41c129a51f9736cc5b7add9dba73a629.pdf";